import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGuardianAuthStore } from '../../stores/guardianAuthStore';
import { Spinner } from '../ui';

interface GuardianProtectedRouteProps {
  children: React.ReactNode;
}

const GuardianProtectedRoute: React.FC<GuardianProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, accessToken } = useGuardianAuthStore();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated || !accessToken) {
    return <Navigate to="/guardian/login" replace />;
  }

  return <>{children}</>;
};

export default GuardianProtectedRoute;